import React, { useState, useEffect } from 'react';
import classes from './PaymentModal.module.css';
import axios from "axios";
import { BASE_URL, withCompanyId } from "../../Components/API/Api";
import verified from "../../Assets/verified.svg";
import crop from "../../Assets/repoort.png";
import Swal from "sweetalert2";
const PaymentModal = ({ isOpen, onClose, onSubmit }) => {
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [formData, setFormData] = useState({
    supplierName: '',
    supplierCode: '',
    contactPerson: '',
    phoneEmail: '',
    invoiceNumbers: '',
    invoiceDate: '',
    dueDate: '',
    currency: 'NGN',
    invoiceAmount: '',
    withholdingTax: '0',
    otherDeductions: '0',
    netPayableAmount: '0.00',
    paymentMethod: '',
    bankName: '',
    accountName: '',
    accountNumber: '',
    paymentReference: '',
    preparedBy: '',
    preparedDate: '',
    checkedBy: '',
    checkedDate: '',
    approvedBy: '',
    approvedDate: '',
    finalApproval: '',
    finalApprovalDate: '',
    notes: ''
  });


  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const options = res.data.data.map((item) => {
          const latestLedger = item.ledgers?.[item.ledgers.length - 1];
          return {
            value: item.id,
            label: item.name,
            phone: item.phone_number || '',
            email: item.email || '',
            balance: latestLedger
              ? parseFloat(latestLedger.balance)
              : parseFloat(item.balance) || 0,
            bankName: item.bank_name || '',
            accountName: item.account_name || '',
            accountNumber: item.account_number || '',
          };
        });
        setSupplierOptions(options);
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
      }
    };

    fetchSuppliers();
  }, []);


  const formatNumber = (num) => {
    if (isNaN(num)) return '';
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleSupplierChange = async (e) => {
    const selectedId = e.target.value;
    const selectedSupplier = supplierOptions.find(
      (s) => String(s.value) === String(selectedId)
    );

    if (selectedSupplier) {
      setFormData((prev) => ({
        ...prev,
        supplierName: selectedSupplier.label,
        supplierCode: selectedSupplier.value,
        contactPerson: formatNumber(selectedSupplier.balance),
        phoneEmail: `${selectedSupplier.phone || ''}${selectedSupplier.email ? ` / ${selectedSupplier.email}` : ''}`,
        bankName: selectedSupplier.bankName,
        accountName: selectedSupplier.accountName,
        accountNumber: selectedSupplier.accountNumber,
        originalBankInfo: {
          bankName: selectedSupplier.bankName,
          accountName: selectedSupplier.accountName,
          accountNumber: selectedSupplier.accountNumber,
        },
      }));

      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(
          `${BASE_URL}/v1/get-pending-supplier-payments?supplier_id=${selectedSupplier.value}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );


        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setInvoiceOptions(res.data.data);
        } else {
          setInvoiceOptions([]);
        }
      } catch (err) {
        console.error("Failed to fetch pending invoices:", err);
        setInvoiceOptions([]);
      }
    }
  };

  const handleAmountChange = (e) => {
    let value = e.target.value;

    value = value.replace(/[^\d.]/g, '');

    const parts = value.split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1] || '';


    if (decimalPart.length > 2) {
      decimalPart = decimalPart.slice(0, 2);
    }


    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Combine parts
    const formatted = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;

    setFormData({
      ...formData,
      amount: formatted,
    });
  };



  const formatAmountWithCommas = () => {
    setFormData((prev) => {
      if (!prev.amount) return { ...prev, amount: '' };
      const number = parseFloat(prev.amount.replace(/,/g, ''));
      return { ...prev, amount: number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) };
    });
  };


  const formatAmount = () => {
    setFormData((prev) => ({
      ...prev,
      amount: prev.amount ? parseFloat(prev.amount).toFixed(2) : '',
    }));
  };

  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const handlePaymentMethodChange = (method) => {
    const methodName = method.name.toLowerCase();
    setSelectedPaymentType(methodName);

    setFormData((prev) => {
      const isCash = methodName === "cash";
      const isBankOrCheque = methodName === "bank" || methodName === "cheque" || methodName === "teller";

      return {
        ...prev,
        paymentMethod: method.id,
        // Clear bank info for cash
        bankName: isCash ? "" : prev.originalBankInfo?.bankName || "",
        accountName: isCash ? "" : prev.originalBankInfo?.accountName || "",
        accountNumber: isCash ? "" : prev.originalBankInfo?.accountNumber || "",
        paymentReference: isCash ? "" : prev.paymentReference, // disable cheque no for cash
      };
    });

    // Also reset selectedBank state if Cash
    if (methodName === "cash") setSelectedBank(null);
  };




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id,
            label: item.name || item.code,
            code: item.code,
          }))
          : [];

        setCurrencyOptions(options);

        const ngnCurrency = options.find((opt) => opt.code === "NGN" || opt.label === "NGN");
        if (ngnCurrency) {
          setSelectedCurrency(ngnCurrency);
        }
      } catch (err) {
        console.error("Failed to fetch currencies:", err);
        setCurrencyOptions([]);
      }
    };

    fetchCurrencies();
  }, []);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [expenseAccounts, setExpenseAccounts] = useState([]);

  const [expenseOptions, setExpenseOptions] = useState([]);

  useEffect(() => {
    const fetchExpenseAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/get-expense-account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          const options = res.data.data.map(item => ({
            value: item.id,
            label: item.gl_name,
          }));
          setExpenseOptions(options);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchExpenseAccounts();
  }, []); useEffect(() => {
    const fetchExpenseAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/get-expense-account`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        setExpenseAccounts(res.data.data || []);
      } catch (err) {
        console.error("Error fetching expense accounts:", err);
        setExpenseAccounts([]);
      }
    };

    fetchExpenseAccounts();
  }, []);

  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/income/get-payment-method-cheque`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPaymentMethods(res.data.data);
      } catch (err) {
        console.error("Failed to fetch payment methods:", err);
      }
    };
    fetchPaymentMethods();
  }, []);
  const [bankOptions, setBankOptions] = useState([]);
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setBankOptions(res.data.data);
        } else {
          setBankOptions([]);
        }
      } catch (err) {
        console.error("Failed to fetch bank/cash accounts:", err);
        setBankOptions([]);
      }
    };
    fetchBanks();
  }, []);

  const [addPaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);

  const calculateNetAmount = () => {
    const amount = parseFloat(formData.invoiceAmount) || 0;
    const tax = parseFloat(formData.withholdingTax) || 0;
    const deductions = parseFloat(formData.otherDeductions) || 0;
    const netAmount = amount - tax - deductions;
    return netAmount.toFixed(2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ validate required fields
    if (
      !selectedInvoice ||
      !formData.notes ||
      !formData.amount ||
      !formData.paymentMethod ||
      !formData.expenseAccount ||
      !selectedCurrency ||
      (selectedPaymentType === "bank" && !selectedBank) // validate bank if bank payment
    ) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill in all required fields before saving.",
        confirmButtonColor: "#16a34a",
      });
      return;
    }

    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");

      const payload = {
        receipt_for: selectedInvoice?.id || selectedInvoice?.value,
        description: formData.notes,
        amount: formData.amount.replace(/,/g, ""),
        mode: formData.paymentMethod,
        currency: selectedCurrency?.value,
        bank: selectedPaymentType === "cash" ? null : selectedBank?.id, // ✅ send null for cash
        expense_account: formData.expenseAccount,
        cheque_no: selectedPaymentType === "cash" ? "" : formData.paymentReference, // ✅ blank for cash
      };


      const res = await axios.post(`${BASE_URL}/v1/pay_supplier`, withCompanyId(payload), {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Payment response:", res.data);

      if (res.data.status === true || res.data.status === "success" || res.data.success) {
        Swal.fire({
          imageUrl: verified,
          title: "Success!",
          text: res.data.message,
          confirmButtonText: "Okay",
          imageWidth: 48,
          imageHeight: 48,
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
          },
          allowOutsideClick: false,
        }).then(() => {
          onClose();
          handleReset();
          // Optionally refresh invoices if needed
          // fetchInvoices();
        });
      } else {
        Swal.fire({
          imageUrl: crop,
          title: "Save Failed",
          text: res.data.message || "The selected bank account is invalid.",
          confirmButtonColor: "#16a34a",
        });
      }

    } catch (err) {
      Swal.fire({
        imageUrl: crop,
        title: "Server Error",
        text: err.response?.data?.message || "Something went wrong. Please try again later.",
        confirmButtonColor: "#16a34a",
      });
    } finally {
      setAddPaymenntLoad(false);
    }
  };





  const handleReset = () => {
    setFormData({
      supplierName: '',
      supplierCode: '',
      contactPerson: '',
      phoneEmail: '',
      invoiceNumbers: '',
      invoiceDate: '',
      dueDate: '',
      currency: 'NGN',
      invoiceAmount: '',
      withholdingTax: '0',
      otherDeductions: '0',
      netPayableAmount: '0.00',
      paymentMethod: '',
      bankName: '',
      accountName: '',
      accountNumber: '',
      paymentReference: '',
      preparedBy: '',
      preparedDate: '',
      checkedBy: '',
      checkedDate: '',
      approvedBy: '',
      approvedDate: '',
      finalApproval: '',
      finalApprovalDate: '',
      notes: ''
    });
  };

  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>
            Supplier / Payables Payment Form
          </h2>
          <p className={classes.modalSubtitle}>
            Promix Accounting — use this form to request supplier payment and capture withholding tax & deductions.
          </p>
          <button className={classes.closeButton} onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className={classes.paymentForm}>
          <div className={classes.formSection}>
            <h3 className={classes.sectionTitle}>1. Supplier Information</h3>

            <div className={classes.formGroup}>
              <label className={classes.formLabel}>Supplier Name</label>
              <select
                name="supplierName"
                value={formData.supplierCode}
                onChange={handleSupplierChange}
                className={classes.formSelect}
                required
              >
                <option value="">Select Supplier</option>
                {supplierOptions.map((sup) => (
                  <option key={sup.value} value={sup.value}>
                    {sup.label}
                  </option>
                ))}
              </select>
            </div>

            <div className={classes.twoColumnGrid}>
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Supplier Code / ID</label>
                <input
                  type="text"
                  name="supplierCode"
                  value={formData.supplierCode}
                  readOnly
                  className={`${classes.formInput} ${classes.readOnlyInput}`}
                />
              </div>

              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Outstanding</label>
                <input
                  type="text"
                  name="contactPerson"
                  value={formData.contactPerson}
                  readOnly
                  className={`${classes.formInput} ${classes.readOnlyInput} ${classes.alignRight}`}
                />
              </div>
            </div>

            <div className={classes.twoColumnGrid}>
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Bank Name</label>
                <input
                  type="text"
                  name="bankName"
                  value={formData.bankName}
                  readOnly
                  className={`${classes.formInput} ${classes.readOnlyInput}`}
                />
              </div>
              {/* <div className={classes.formGroup}>
                <label className={classes.formLabel}>Account Number / IBAN</label>
                <input
                  type="text"
                  name="accountNumber"
                  value={formData.accountNumber}
                  readOnly
                  className={`${classes.formInput} ${classes.readOnlyInput}`}
                />
              </div> */}
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Account Name</label>
                <input
                  type="text"
                  name="accountName"
                  value={formData.accountName}
                  readOnly
                  className={`${classes.formInput} ${classes.readOnlyInput}`}
                />
              </div>

            </div>

            <div className={classes.formGroup}>
              <label className={classes.formLabel}>Phone / Email</label>
              <input
                type="text"
                name="phoneEmail"
                value={formData.phoneEmail}
                readOnly
                className={`${classes.formInput} ${classes.readOnlyInput}`}
              />
            </div>
          </div>


          <div className={classes.formSection}>
            <h3 className={classes.sectionTitle}>2. Invoice / Payment Details</h3>

            <div className={classes.formGroup}>
              <label className={classes.formLabel}>Invoice Number(s)</label>
              <select
                name="invoiceNumbers"
                value={formData.invoiceNumbers}
                onChange={(e) => {
                  const selected = invoiceOptions.find(
                    (i) => i.invoice_number === e.target.value
                  );
                  if (selected) {
                    setFormData((prev) => ({
                      ...prev,
                      invoiceNumbers: selected.invoice_number,
                      invoiceDate: selected.date_of_invoice || '',
                      dueDate: selected.transaction_date || '',
                      invoiceAmount: selected.amount || '',
                      currency: selected.currency || prev.currency, // fallback to existing
                    }));
                    setSelectedInvoice(selected);
                  }
                }}
                className={classes.formSelect}
                required
              >
                <option value="">Select Invoice</option>
                {invoiceOptions.map((inv) => (
                  <option key={inv.id} value={inv.invoice_number}>
                    {inv.invoice_number}
                  </option>
                ))}
              </select>
            </div>


            <div className={classes.twoColumnGrid}>
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Invoice Date</label>
                <input
                  type="date"
                  name="invoiceDate"
                  value={formData.invoiceDate}
                  onChange={handleInputChange}
                  className={classes.formInput}
                />
              </div>

              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Due Date</label>
                <input
                  type="date"
                  name="dueDate"
                  value={formData.dueDate}
                  onChange={handleInputChange}
                  className={classes.formInput}
                />
              </div>
            </div>

            <div className={classes.threeColumnGrid}>
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Currency</label>
                <div className={classes.formSelectWrapper}>
                  <select
                    name="currency"
                    value={selectedCurrency?.value || ''}
                    onChange={(e) => {
                      const selected = currencyOptions.find((opt) => opt.value === e.target.value);
                      setSelectedCurrency(selected);
                      setFormData((prev) => ({ ...prev, currency: selected?.value }));
                    }}
                    className={classes.formSelect}
                  >
                    <option value="">Select Currency</option>
                    {currencyOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>


              </div>




              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Invoice Amount</label>
                <input
                  type="number"
                  name="invoiceAmount"
                  value={formData.invoiceAmount}
                  onChange={handleInputChange}
                  step="0.01"
                  className={classes.formInput}
                />
              </div>

            </div>

            {/* <div className={classes.twoColumnGrid}>
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Less: Other Deductions</label>
                <input
                  type="number"
                  name="otherDeductions"
                  value={formData.otherDeductions}
                  onChange={handleInputChange}
                  step="0.01"
                  className={classes.formInput}
                />
              </div>

              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Net Payable Amount</label>
                <input
                  type="text"
                  name="netPayableAmount"
                  value={calculateNetAmount()}
                  readOnly
                  className={`${classes.formInput} ${classes.readOnlyInput}`}
                />
              </div>
            </div> */}
          </div>

          {/* Section 3: Payment Method */}
          <div className={classes.formSection}>
            <h3 className={classes.sectionTitle}>3. Payment Method</h3>
            <div className={classes.paymentMethodOptions}>
              {paymentMethods.map((method) => (
                <label key={method.id} className={classes.radioLabel}>
                  <input
                    type="radio"
                    name="paymentMethod"
                    checked={formData.paymentMethod === method.id}
                    onChange={() => handlePaymentMethodChange(method)}
                    className={classes.radioInput}
                  />
                  {method.name}
                </label>
              ))}
            </div>


            <div className={classes.twoColumnGrid}>
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Bank Name</label>
                <select
                  name="bankName"
                  value={selectedBank?.id || ''}
                  onChange={(e) => {
                    const bank = bankOptions.find(b => b.id === parseInt(e.target.value));
                    setSelectedBank(bank);
                    setFormData(prev => ({ ...prev, bankName: bank?.gl_name || '' }));
                  }}
                  disabled={selectedPaymentType === "cash"}
                >
                  <option value="">Select Bank</option>
                  {bankOptions.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.gl_name}
                    </option>
                  ))}
                </select>


              </div>

              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Expense Account</label>
                <div className={classes.formSelectWrapper}>
                  <select
                    name="expenseAccount"
                    value={formData.expenseAccount || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        expenseAccount: e.target.value,
                      }))
                    }
                    className={classes.formSelect}
                  >
                    <option value="">Select Expense Account</option>
                    {expenseOptions.map((acc) => (
                      <option key={acc.value} value={acc.value}>
                        {acc.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* 
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Account Name</label>
                <input
                  type="text"
                  name="accountName"
                  value={formData.accountName}
                  readOnly
                  className={`${classes.formInput} ${classes.readOnlyInput}`}
                />
              </div> */}
            </div>

            <div className={classes.twoColumnGrid}>
              <div className={classes.formGroup}>
                <label className={classes.formLabel}>Payment Reference / Cheque No.</label>
                <input
                  type="text"
                  name="paymentReference"
                  value={formData.paymentReference}
                  onChange={handleInputChange}
                  className={classes.formInput}
                  disabled={selectedPaymentType === "bank" || selectedPaymentType === "bank transfer"}
                />

              </div>
              <div className={classes.twoColumnGrid}>

                <div className={classes.formGroup}>
                  <label className={classes.formLabel}>Amount</label>
                  <input
                    type="text"
                    name="amount"
                    value={formData.amount}
                    onChange={handleAmountChange}
                    className={`${classes.formInput} ${classes.rightAlignInput}`}
                    placeholder="0.00"
                  />
                </div>
                <div className={classes.formGroup}>
                  <label className={classes.formLabel}>Currency</label>
                  <div className={classes.formSelectWrapper}>
                    <select
                      name="currency"
                      value={selectedCurrency?.value || ''}
                      onChange={(e) => {
                        const selected = currencyOptions.find((opt) => opt.value === e.target.value);
                        setSelectedCurrency(selected);
                        setFormData((prev) => ({ ...prev, currency: selected?.value }));
                      }}
                      className={classes.formSelect}
                    >
                      <option value="">Select Currency</option>
                      {currencyOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>


                </div>
              </div>


            </div>


          </div>


          <div className={classes.formSection}>
            <h3 className={classes.sectionTitle}>5. Notes / Remarks</h3>
            <div className={classes.formGroup}>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleInputChange}
                placeholder="Optional notes, payment conditions, or instructions..."
                className={classes.textarea}
                rows="4"
              />
            </div>
            <div className={classes.helpText}>
              Tip: use Print / Save PDF to export a printable copy.
            </div>
          </div>

          {/* Form Actions */}
          <div className={classes.formActions}>
            <button type="button" onClick={handleReset} className={classes.resetButton}>
              Reset
            </button>
            <button type="button" className={classes.printButton}>
              Print / Save PDF
            </button>
            <button type="submit" className={classes.submitButton} disabled={addPaymenntLoad}>
              {addPaymenntLoad ? "Submitting..." : "Submit"}
            </button>

          </div>
        </form>
      </div >
    </div >
  );
};

export default PaymentModal;
